<!-- SEARCH INPUT -->
@if (selectedDateRange != null) {
  <div class="interval-dropdown">
    <button data-testid="calendar-open-button" type="button" [disabled]="disabled" [dropdownTriggerFor]="dropdown" (dropdownClosed)="onClose()">
      <svg-icon key="calendar" class="calendar-icon" />
      <span class="label">{{ selectedRangeLabel }}</span>
      <span class="chevron-icon">
        <svg-icon key="arrow-button-down" />
      </span>
    </button>
  </div>
  <app-dropdown #dropdown [closeOnClick]="false">
    <div class="calendar-dropdown-container">
      @if (showShortcuts) {
        <div class="day-button-group">
          @for (shortcut of shortcuts; track shortcut) {
            <button class="btn btn-set-interval" [ngClass]="{ selected: shortcut.selected, disabled: shortcut.disabled }" [disabled]="shortcut.disabled" (click)="setRangeManually(shortcut)">
              {{ shortcut.label }}
            </button>
          }
        </div>
      }
      <div class="inline-calendar-card">
        <mat-calendar
          #calendar
          data-testid="calendar"
          [selected]="selectedDateRange"
          [dateClass]="setClass()"
          [startAt]="startAt"
          [minDate]="minDate"
          [headerComponent]="customCalendarHeader"
          (selectedChange)="selectedChanged($event)"
          (viewChanged)="viewChanged($event)"
          class="calendar"
        />
      </div>
    </div>
  </app-dropdown>
}
